package com.essntl.features.invoice.ui.addeditinvoice

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.invoice.ui.addeditinvoice.components.AddEditInvoiceContent
import com.essntl.features.invoice.ui.addeditinvoice.components.AddEditInvoiceSideBar
import com.essntl.features.invoice.ui.addeditinvoice.components.AddEditInvoiceSideBarTotal
import com.essntl.features.invoice.ui.addeditinvoice.components.QuickbooksRefreshWebpageDialog
import com.essntl.uikit.components.utils.spacing

@Composable
fun AddEditInvoiceScreen(
    state: AddEditInvoiceState,
    onEvent: (AddEditInvoiceEvent) -> Unit,
    onNavigation: (AddEditInvoiceNavigation) -> Unit,
    validation: AddEditInvoiceValidation,
) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(1.spacing),
        modifier = Modifier.fillMaxSize(),
    ) {
        AddEditInvoiceContent(
            state = state,
            validation = validation,
            onEvent = onEvent,
            onNavigation = onNavigation,
            modifier = Modifier.weight(2f),
        )

        Column(
            verticalArrangement = Arrangement.spacedBy(1.spacing),
            modifier = Modifier
                .weight(1f)
                .verticalScroll(rememberScrollState()),
        ) {
            if (state.isLoading || state.isFailure)
                return@Column

            AddEditInvoiceSideBar(
                state = state,
                validation = validation,
                onEvent = onEvent,
            )

            if (!state.getInvoice.data?.id.isNullOrEmpty())
                AddEditInvoiceSideBarTotal(state = state)
        }
    }

    if (state.openQuickbooksRefreshWebpage)
        QuickbooksRefreshWebpageDialog(
            onDismissRequest = {
                onEvent(AddEditInvoiceEvent.CloseQuickbooksRefreshWebpage)
            },
        )
}